import { SpinProps } from "@arco-design/web-react";

// 定义渲染类型的枚举
export enum InfiniteRenderType {
  PAGINATED_BY_PAGE = 1,
  PAGINATED_ALL_DATA = 2,
  NO_PAGINATION = 3,
}

type PagePaginationProps = {
  currentPage?: number;
  loadMorePage?: number;
  totalPage?: number;
};

type AllDataPaginationProps = {
  currentPage?: number;
  pageSize?: number;
  loadMorePage?: number;
};

type PageProps = {
  type: InfiniteRenderType.PAGINATED_BY_PAGE;
  pagination: PagePaginationProps;
};

type AllDataProps = {
  type: InfiniteRenderType.PAGINATED_ALL_DATA;
  pagination: AllDataPaginationProps;
};

type NoPageProps = {
  type: InfiniteRenderType.NO_PAGINATION;
};

type RenderTypeProps = PageProps | AllDataProps | NoPageProps;

interface ScrollSpinProps extends SpinProps {
  loading: boolean;
  position?: "center" | "bottom";
}

export type InfiniteScrollProps<T> = {
  loading: boolean | ScrollSpinProps;
  data?: T[];
  scrollToBottomTrigger?: (page: number) => void;
  renderItem: (item: T, index: number) => React.ReactNode;
} & RenderTypeProps;
